import { AtomicBlueprintSupported } from "../shared/atomic/atomic.component";
import { CountryChartComponent } from "./countryChart/country-chart.component";
import { FootnotesComponent } from "./footnotes/footnotes.component";
import { GenericChartComponent } from "./generic-chart/generic-chart.component";
import { GenericTableComponent } from "./generic-table/generic-table.component";
import { HeadlineComponent } from "./headline/headline.component";

export const ATOMIC_MAPPING = {
  headline: HeadlineComponent,
  footnotes: FootnotesComponent,
  genericChart: GenericChartComponent,
  genericTable: GenericTableComponent,
  countryTable: CountryChartComponent 
} satisfies Record<string, new () => AtomicBlueprintSupported<any>>;